// Story 11.4 — `useDeployments(botId)`: lista de versions para Rollback dialog.

import { useQuery } from '@tanstack/react-query';
import { type DeploymentRow, deploymentsApi } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

export function useDeployments(
  botId: number,
  opts: { limit?: number; offset?: number } = {},
  enabled = true,
) {
  return useQuery<DeploymentRow[]>({
    queryKey: queryKeys.deployments(botId),
    queryFn: () => deploymentsApi.list(botId, opts),
    enabled: enabled && Number.isFinite(botId),
    staleTime: 30_000,
  });
}
